import createAxios from './api'

const PATH = 'users'

export default {
  async joinUser() {
    const axios = await createAxios()
    const resp = await axios.put(`${PATH}`)

    return resp.data
  },

  async createUser(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}`, req)

    return resp.data
  },

  async listUsers(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async listEnabledUsers(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/enabled`, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateMyUser(user) {
    const axios = await createAxios()
    await axios.put(`${PATH}/self`, user)
  },

  async updateMyLocale(locale) {
    const axios = await createAxios()
    await axios.put(`${PATH}/self/locale`, locale)
  },

  async updateUser(id, q) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, q)
  },

  async getMyUser() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`)

    return resp.data
  },

  async getUser(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async deleteUser(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  },

  async getMyUserStats() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self/stats`)
    return resp.data
  },

  async getDefaultRoles() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/defaultRoles`)
    return resp.data
  },

  async getMyBusinessAccountInvitations() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self/businessAccountInvitations`)
    return resp.data
  }

}
